import { render, staticRenderFns } from "./RefundSlips.vue?vue&type=template&id=2f546de7&"
import script from "./RefundSlips.vue?vue&type=script&lang=js&"
export * from "./RefundSlips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports